import React from 'react'
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material'
import * as Sentry from '@sentry/react'
import { render } from 'preact'
import { DEFAULT_THEME } from 'src/theme/index.theme'

import 'preact/debug'

import { AcRouter } from './routes/ac-router.routes'

import './styles/global.scss'

const root = document.getElementById('root') as HTMLElement
const globalStyles = (
  <GlobalStyles
    styles={{
      html: {
        height: '100%',
      },
      body: {
        height: '100%',
        maxHeight: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    }}
  />
)

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: process.env.REACT_APP_SENTRY_SAMPLE_RATE ? parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE) : 0,
  beforeSend(event, hint) {
    const error = hint?.originalException
    if (error && typeof error === 'object' && 'response' in error) {
      const status = (error as { response?: { status?: number } }).response?.status
      if (status && status >= 400 && status < 500 && status !== 429) {
        return null // Don't send 4xx errors to Sentry (except 429)
      }
    }
    return event
  },
})

// HubSpot Embed Script Loading
const hubspotId = process.env.REACT_APP_HUBSPOT_ID;

if (hubspotId) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'hs-script-loader';
  script.async = true;
  script.defer = true;
  script.src = `//js.hs-scripts.com/${hubspotId}.js`;
  document.body.appendChild(script);
}

render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      {globalStyles}
      <ThemeProvider theme={DEFAULT_THEME}>
        <CssBaseline />
        <AcRouter />
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  root,
)
